
import { Component } from 'vue-property-decorator';
import StackedForm from '../../../mixins/StackedForm';
import { mixins } from 'vue-class-component';
import { InputType } from '@/enums/InputType';
import VFormBuilder from '@/components/shared/form/VFormBuilder.vue';
import { Article } from '@/interfaces/models/Article';
import { ExternalOrderProvider } from '@/enums/ExternalOrderProvider';
import { Asset } from '@/interfaces/models/Asset';
import { resolveProviderImageForSave } from '@/util/providerImage';

@Component({
  components: { VFormBuilder },
})
export default class DeliverooOptionsForm extends mixins(StackedForm) {
  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { getData: () => any; validate: () => Promise<boolean | boolean[]> };
  };

  get items() {
    return [
      {
        name: 'visible',
        type: InputType.Checkbox,
        default: true,
        label: 'article.form.visible',
      },
      {
        name: 'takeAwayPrice',
        type: InputType.Price,
        label: 'article.form.takeAwayPrice',
      },
      {
        name: 'deliveryPrice',
        type: InputType.Price,
        label: 'article.form.deliveryPrice',
      },
      {
        name: 'image',
        type: InputType.DragAndDropImage,
        label: 'article.form.providerImage',
        default: null,
        accept: 'image/*',
        hint: this.$t('common.imageMaxSizeNotice', { max: 10 }),
        max: 10,
      },
    ];
  }

  get internalInitialValues() {
    const deliverooProvider = (this.initialValues as Article | undefined)?.externalOrderProviderSettings?.find(
      (settings) => settings.provider === ExternalOrderProvider.DELIVEROO,
    );

    if (!deliverooProvider) {
      return null;
    }

    return deliverooProvider;
  }

  public getData() {
    const data: any = { ...this.$refs.form.form };
    const filesToRemove: string[] = this.$refs.form.getFilesToRemove();
    const image = resolveProviderImageForSave(
      data.image,
      this.internalInitialValues?.image as Asset | undefined,
      filesToRemove.indexOf('image') > -1,
    );

    if (image === undefined) {
      delete data.image;
    } else {
      data.image = image;
    }

    return data;
  }
}
